<td-wb-tooltip-button class="td-wb-rate-of-return-tooltip__button"
                      [tdWbOverlayToggle]="rateOfReturnTooltipTemplate"
                      tooltipSize="small"
                      [tooltipPosition]="position()"
                      [attr.aria-describedby]="ariaDescribedBy()"
                      [ariaLabel]="'tdWb.components.performance.performanceViewOverlay.LINK_LABEL' | tdWbTranslate" />
  <ng-template #rateOfReturnTooltipTemplate>
    <td-wb-overlay>
      @if (changeLink()) {
        <p class="td-wb-rate-of-return-tooltip__body"
           [innerHtml]="'tdWb.components.performance.performanceViewOverlay.CHANGE_ROR_LABEL' | tdWbTranslate">
        </p>
      }
      <p class="td-wb-rate-of-return-tooltip__body"
         translate="tdWb.components.performance.performanceViewOverlay.LEARN_DIFFERENCES_LABEL">
      </p>
      <div class="td-wb-overlay__content__links">
        @if (changeLink()) {
          <a class="td-wb-rate-of-return-tooltip__link"
             tdWbHref="link_preferences_ror">
            <span translate="tdWb.components.performance.performanceViewOverlay.CHANGE_LINK">
            </span>
            <td-wb-icon iconId="caret-right--small"
                        [inline]="true" />
          </a>
        }
        <a tdWbHref="link_ror_video"
           target="_blank"
           rel="noopener">
          <span translate="tdWb.components.performance.performanceViewOverlay.WATCH_VIDEO_LINK">
          </span>
          <td-wb-icon iconId="caret-right--small"
                      [inline]="true" />
        </a>
      </div>
    </td-wb-overlay>
  </ng-template>
